"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapResults = exports.createEndpointSdk = void 0;
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
var _config = require("../config");
var _constants = require("../constants");
var _withQueryClient = require("../issuesQueryClient/withQueryClient");
var _issuesQueryClient = require("../issuesQueryClient");
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const mapResults = mapFn => payload => ({
  results: payload.results.map(mapFn),
  pagination: payload.pagination
});
exports.mapResults = mapResults;
/**
 * Creates an SDK for an API endpoint that can be instantiated by calling it with a config object.
 * @param {Function<EndpointSDK>} factory A function that upon being called returns the SDK object.
 * @param {object} options Endpoint options. object.
 */
const createEndpointSdk = (factory, _ref) => {
  let {
    origin = "".concat((0, _acsScWebPlatformApi.getApigeeUrl)()).concat((0, _config.getIssuesPath)()),
    basePath,
    projectsKeyword = "projects",
    ...queryClientOptions
  } = _ref;
  return _ref2 => {
    var _basePath;
    let {
      projectId,
      headers = {},
      useReactQuery
    } = _ref2;
    basePath = (_basePath = basePath) !== null && _basePath !== void 0 ? _basePath : "".concat(projectsKeyword, "/").concat(projectId);
    const baseUrl = "".concat(origin, "/").concat(basePath);
    const queryClient = (0, _issuesQueryClient.getIssuesQueryClientInstance)();
    const request = (0, _withQueryClient.withQueryClient)(useReactQuery ? queryClient : undefined, queryClientOptions)(function (url) {
      let method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.HttpMethod.Get;
      let body = arguments.length > 2 ? arguments[2] : undefined;
      const fetchData = {
        method,
        headers: {
          ..._constants.defaultHeaders,
          ...headers
        }
      };
      if (body && method !== _constants.HttpMethod.Get && method !== _constants.HttpMethod.Delete) {
        Object.assign(fetchData, {
          body: JSON.stringify(body)
        });
      }
      return (0, _acsScWebPlatformApi.fetchWithToken)("".concat(baseUrl, "/").concat(url), fetchData);
    });
    const api = {
      request,
      ...(0, _mapValues.default)({
        get: [_constants.HttpMethod.Get, _constants.RequestType.Query],
        delete: [_constants.HttpMethod.Delete, _constants.RequestType.Mutation],
        create: [_constants.HttpMethod.Post, _constants.RequestType.Mutation],
        update: [_constants.HttpMethod.Patch, _constants.RequestType.Mutation],
        getAll: [_constants.HttpMethod.Get, _constants.RequestType.Query],
        batchCreate: [_constants.HttpMethod.Post, _constants.RequestType.Mutation],
        batchGet: [_constants.HttpMethod.Post, _constants.RequestType.Query],
        batchUpdate: [_constants.HttpMethod.Patch, _constants.RequestType.Mutation],
        batchDelete: [_constants.HttpMethod.Post, _constants.RequestType.Mutation],
        set: [_constants.HttpMethod.Put, _constants.RequestType.Mutation]
      }, _ref3 => {
        let [method, requestType] = _ref3;
        // Maps every SDK verb to an HTTP-method bound request function
        return method === _constants.HttpMethod.Get || method === _constants.HttpMethod.Delete ? (url, options) => request(url, method, undefined, {
          ...options,
          requestType
        }) : (url, body, options) => request(url, method, body, {
          ...options,
          requestType
        });
      })
    };
    return factory({
      api,
      queryClient,
      projectId
    });
  };
};
exports.createEndpointSdk = createEndpointSdk;
//# sourceMappingURL=endpointHelpers.js.map